"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.getFunctionFromGlobal = getFunctionFromGlobal;

var _propget = _interopRequireDefault(require("propget"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Search target for nested properties and return it.
 *
 * @param {string} target global target
 * @param {string} properties Object properties.
 * @returns {Mixed|undefined} Result of lookup or undefined.
 */
function get(target, properties) {
  var targets = {
    get global() {
      return typeof global !== 'undefined' && global;
    },

    get window() {
      return typeof window !== 'undefined' && window;
    }

  };
  return (0, _propget["default"])(targets[target], properties);
}
/**
 * Gets the function found in `global['@native/shell']` by the name provided.
 *
 * @param {String} functionName Name of the function to find
 * @returns {Function} Returns the function if found, undefined otherwise
 */


function getFunctionFromGlobal(functionName) {
  return get('global', "@native/shell.".concat(functionName));
}